import { Diagnostic, IoCContainer, ISensitiveSettings, ISensitiveSettingsStorage, IUtils, WebCoreIoCKeys } from 'web-core-src';

export abstract class SensitiveSettingsStorageBase implements ISensitiveSettingsStorage {
    // todo: ezt meg az egyéb base sensitive settings classokat össze lehet vonni a sima settings classokkal
    //replaced by the webpack build
    public static VERSION: string = '@version';

    public static V_VERSION_SNAKE_CASE: string = 'v0_0_99';

    private debugModeForSettingStorage: boolean = false;
    private appSettings: ISensitiveSettings;

    protected abstract getSettingsFromStorage(): Promise<any>;
    protected abstract setSettingsToStorage(settings: any): Promise<void>;

    public async resetAllModuleSettingsWithDefaultValues(): Promise<void> {
        Diagnostic.debug('SensitiveSettingsStorageBase - resetAllModuleSettingsWithDefaultValues started');

        this.appSettings.setDefaultValues();

        await this.updateSettingsInStorage();
        Diagnostic.debug('SensitiveSettingsStorageBase - resetAllModuleSettingsWithDefaultValues ended');
        this.translateDefaultValues();
    }

    public async updateSettingsInStorage(): Promise<void> {
        Diagnostic.debug('SensitiveSettingsStorageBase - updateSettingsInStorage started');
        this.DebuggerDebug('SensitiveSettingsStorageBase - updateSettingsInStorage - setSettingsToStorage started');
        await this.setSettingsToStorage(this.appSettings);
        Diagnostic.debug('SensitiveSettingsStorageBase - updateSettingsInStorage ended');

        return Promise.resolve();
    }

    public initSettingsStorage(appSettings: ISensitiveSettings, coreSettings: ISensitiveSettings): void {
        appSettings.settingsStorage = this;
        appSettings.version = SensitiveSettingsStorageBase.VERSION;
        coreSettings.settingsStorage = this;

        this.appSettings = appSettings;
        this.appSettings['core'] = coreSettings;
    }

    public async initSettings(appSettings: ISensitiveSettings, coreSettings: ISensitiveSettings): Promise<void> {
        this.initSettingsStorage(appSettings, coreSettings);

        let settings = await this.getSettingsFromStorage();
        this.loadSettings(settings);

        return Promise.resolve();
    }

    private translateDefaultValues(): void {
        this.DebuggerDebug('SensitiveSettingsStorageBase - translateDefaultValues started');
        this.appSettings.translateDefaultValues();
        this.DebuggerDebug('SensitiveSettingsStorageBase - translateDefaultValues ended');
    }

    public setAppSettings(settingsJsonString: string): void {
        let settingsJson = this.settingsJsonParse(settingsJsonString);
        this.loadSettings(settingsJson);
    }

    public getAppSettings(): ISensitiveSettings {
        return this.appSettings;
    }

    private loadSettings(settings: any): void {
        let utils: IUtils = IoCContainer.get(WebCoreIoCKeys.IUtils);
        utils.deepCopy(this.appSettings, settings);

        this.appSettings.settingsStorage = this;
        this.appSettings['core'].settingsStorage = this;
    }

    protected settingsJsonParse(settingsJsonString: string): any {
        return JSON.parse(settingsJsonString, this.jsonPropertyReviver);
    }

    public async loadSettingsFromStorage(): Promise<void> {
        this.DebuggerDebug('SensitiveSettingsStorageBase - loadSettingsFromStorage started');
        let settingsJson = await this.getSettingsFromStorage();

        this.DebuggerDebug('SensitiveSettingsStorageBase - loadSettingsFromStorage - getSettingsFromStorage - result', settingsJson);

        this.loadSettings(settingsJson);

        this.DebuggerDebug('SensitiveSettingsStorageBase - loadSettingsFromStorage ended');
        return Promise.resolve();
    }

    public getCurrentSettingsJSON(): string {
        return this.getSettingsJSON(this.appSettings);
    }

    protected getSettingsJSON(settings: any): string {
        return JSON.stringify(settings, this.jsonPropertyReplace);
    }

    protected jsonPropertyReplace(propertyName: string, value: any): any {
        if (propertyName == 'settingsStorage') {
            return undefined;
        }
        // if (value instanceof Date) {
        //     return '¤¤¤-' + value.getTime() + '-' + value.toJSON();
        // }

        return value;
    }

    protected jsonPropertyReviver(propertyName, value): Date {
        let reISO = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*))(?:Z|(\+|-)([\d|:]*))?$/;
        let reMsAjax = /^\/Date\((d|-|.*)\)[\/|\\]$/;
        if (typeof value === 'string') {
            var a = reISO.exec(value);
            if (a) {
                return new Date(value);
            }
            a = reMsAjax.exec(value);
            if (a) {
                var b = a[1].split(/[-+,.]/);
                return new Date(b[0] ? +b[0] : 0 - +b[1]);
            }
        }
        return value;
    }

    protected DebuggerDebug(text: string, ...optionalParams: any[]): void {
        if (this.debugModeForSettingStorage) {
            Diagnostic.debug(text, optionalParams);
        }
    }
}

// export class SettingEvents {
//     public static SETTING_CHANGED: string = 'SettingChanged';
// }
